const unitString = (unit) => (val) => `${val}${unit}`;
export default unitString;
